import { render, staticRenderFns } from "./OratoriDiscorso.vue?vue&type=template&id=5ad2c70c&scoped=true&"
import script from "./OratoriDiscorso.vue?vue&type=script&lang=js&"
export * from "./OratoriDiscorso.vue?vue&type=script&lang=js&"
import style0 from "./OratoriDiscorso.vue?vue&type=style&index=0&id=5ad2c70c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2c70c",
  null
  
)

export default component.exports